export { default as InjectableItemPage } from './components/InjectableItemPage';
export const InjectableItemPageDynamic = () => import('./components/InjectableItemPage');
